<script>
    import { Bar } from 'vue-chartjs';
    import { getMemberSubscriptionEvolution } from '@/api/statistics-api';

    export default {
        name: "MembersSubscriptionEvolution",
        extends: Bar,

        data: () => ({
           labels: [],
           datasets: [
               {
                   label: 'Altas',
                   backgroundColor: '#68BD7B',
                   data: []
               },
               {
                   label: 'Bajas',
                   backgroundColor: '#f87979',
                   data: []
               }
           ]
        }),

        mounted () {
            this.getChartData();
            this.render();
        },

        methods: {

            render() {
                this.renderChart({
                    labels: this.labels,
                    datasets: this.datasets,
                }, {responsive: true, maintainAspectRatio: false});
            },

            getChartData() {
                getMemberSubscriptionEvolution().then((data) => {

                    let labels = [];
                    let subscribe = [];
                    let unsubscribe = [];

                    data.forEach((memberSubscription) => {
                        labels.push(memberSubscription.date);
                        subscribe.push(memberSubscription.subscriptions);
                        unsubscribe.push(memberSubscription.un_subscriptions);
                    });

                    this.labels = labels;
                    this.datasets[0].data = subscribe;
                    this.datasets[1].data = unsubscribe;

                    this.render();
                });
            },

        }
    }
</script>